<template>
  <div>
    <div class="employee">
      <span class="name">
        {{ data.employee && data.employee.name ? data.employee.name : '-' }}
      </span>
      <span class="employee_ride-info">{{ rideDateTime || '-' }}</span>
    </div>

    <ul class="ride">
      <li>
        <span class="item__label">{{ $t(`${namespace}.origin`) }}</span>
        <span class="item__text">
          <span v-if="data.start && data.start.address" :title="data.start.address">
            <span class="text--ellipsis">{{ data.start.address }}</span>
            <span class="text--ellipsis">{{ data.start.address | getStateAndCountry }}</span>
          </span>
          <span v-else>-</span>
        </span>
      </li>

      <li>
        <span class="item__label">{{ $t(`${namespace}.destiny`) }}</span>
        <span class="item__text">
          <span v-if="data.end && data.end.address" :title="data.end.address">
            <span class="text--ellipsis">{{ data.end.address }}</span>
            <span class="text--ellipsis">{{ data.end.address | getStateAndCountry }}</span>
          </span>
          <span v-else>-</span>
        </span>
      </li>
    </ul>

    <div v-if="data.fare" class="mb-2">
      <div class="item__label text-capitalize">{{ $t('Common.value') }}</div>
      <div>{{ data.fare | currencyBRL }}</div>
    </div>

    <div v-if="getRideCategory(data.taxiCategoryName)" class="mb-2">
      <div class="item__label text-capitalize">{{ $t('Common.category') }}</div>
      <div>{{ getRideCategory(data.taxiCategoryName) }}</div>
    </div>

    <div v-if="['delivery'].includes(getRideCategoryBizType(data.taxiCategoryName)) && data.receiver">
      <div v-if="data.receiver.name" class="mb-2">
        <div class="item__label">{{ $t(`${namespace}.receiverName`) }}</div>
        <div>{{ data.receiver.name }}</div>
      </div>

      <div v-if="data.receiver.phone" class="mb-2">
        <div class="item__label">{{ $t(`${namespace}.receiverPhone`) }}</div>
        <div>{{ data.receiver.phone.replace('+55', '') | phoneWithDDD }}</div>
      </div>
    </div>

    <div v-if="data.start && data.start.date && data.end && data.end.date" class="mb-2">
      <div class="item__label text-capitalize">{{ $t('Common.duration') }}</div>
      <div>{{ data.start.date | duration(data.end.date) }} {{ $t('Common.minutes') }}</div>
    </div>

    <div v-if="data.odometer" class="mb-2">
      <div class="item__label text-capitalize">{{ $t('Common.distance') }}</div>
      <div>{{ data.odometer | metresToKm }}</div>
    </div>

    <div v-if="data.note" class="mb-2">
      <div class="item__label text-capitalize">{{ $t('Common.justification') }}</div>
      <div>{{ data.note | normalizeString }}</div>
    </div>

    <div v-if="data.callPlatform">
      <div class="item__label text-capitalize">{{ $t('Common.platform') }}</div>
      <div class="text-capitalize">{{ data.callPlatform }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getRideCategory, getRideCategoryByAttr } from 'utils/functions'

export default {
  name: 'TabRide',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    normalizeString (val) {
      return val ? val.replace(/\+/g, ' ') : null
    }
  },
  computed: {
    rideDateTime () {
      const { start = null, end = null } = this.data

      if (
        this.data &&
        start && start.date &&
        end && end.date
      ) {
        return `${moment(start.date).format('DD/MM/YYYY')} ${this.$t(`${this.namespace}.of`)} ${moment(start.date).format('HH:mm')} ${this.$t(`${this.namespace}.at`)}  ${moment(end.date).format('HH:mm')}`
      }

      return null
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.reports.tabs'
    }
  },
  methods: {
    getRideCategory (category = '') {
      return getRideCategory(this, category).text
    },
    getRideCategoryBizType (value = '') {
      return getRideCategoryByAttr(this, { key: 'taxiCategoryName', value: value }).bizType
    }
  }
}
</script>

<style lang="scss" scoped>
.employee_ride-info {
  display: block;
}

.ride {
  list-style-type: none;
  margin: 16px 0;
  padding: 0 0 0 24px;
  position: relative;

  &:before {
    bottom: 50px;
    border-left: 2px solid $accent;
    content: '';
    left: 10px;
    position: absolute;
    top: 5px;
    width: 1px;
  }

  li {
    margin-bottom: 8px;
    position: relative;

    &:before,
    &:after {
      border-radius: 50%;
      content: '';
      position: absolute;
    }

    &:before {
      background-color: #fff;
      border: 2px solid $accent;
      height: 14px;
      left: -20px;
      top: 2px;
      width: 14px;
      z-index: 1;
    }

    &:after {
      background-color: $accent;
      height: 6px;
      left: -16px;
      top: 6px;
      width: 6px;
      z-index: 2;
    }
  }
}
</style>
